const endpoints = {
  listRemunerationsCommission: (): string => `remuneration/commission`,
};

export default endpoints;
